import { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("¡Listo! Te suscribimos al newsletter de popu.news");
      setEmail("");
    } catch {
      toast.error("Ups, no pudimos suscribirte. Intentá de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="rounded-sm p-5 text-white"
      style={{
        background: `linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%)`,
        wordBreak: "break-word",
      }}
      data-testid="newsletter-cta"
    >
      <Sparkles size={20} className="mb-2" />
      <h3 className="font-headline uppercase text-base leading-tight mb-2">
        ✦ SOMOS<br />INFLUCAST
      </h3>
      <p className="text-xs text-white/90 mb-3 leading-snug">
        Lo mejor del pop, cultura y tendencias en tu correo.
      </p>
      <form onSubmit={submit} className="space-y-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Tu correo"
          className="w-full min-w-0 px-2.5 py-2 rounded-sm bg-white/95 text-black outline-none text-xs focus:ring-2 focus:ring-white"
          data-testid="newsletter-email"
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 bg-black text-white text-[10px] font-bold uppercase tracking-wider rounded-sm hover:bg-black/80 transition disabled:opacity-50"
          data-testid="newsletter-submit"
        >
          {loading ? "Enviando..." : "Suscribirme"}
        </button>
      </form>
    </div>
  );
}
